import Vue from 'vue';

/**********************************************
 * カート系
 */
export default Vue.filter('money', val => {
  if (!val) val = 0;
  const money = val.toString().replace(/([0-9]+?)(?=(?:[0-9]{3})+$)/g, '$1,');
  return money + '円';
});
Vue.filter('centimeters', (val) => {
  if (!val) return;
  return (val / 10).toFixed(1) + 'cm';
});
/**********************************************
 * 数字系
 */
Vue.filter('zeroPadding', (val, length=4) => {
  if (!val) return 0;
  return ('0000000000' + val).slice(-length);
});
